import SendBird from 'sendbird'

function getMessengerClient () {
  if (!window.marketplace.state.app.messengerClient) {
    window.marketplace.state.app.messengerClient = SendBird.getInstance()
  }

  return window.marketplace.state.app.messengerClient
}

export {getMessengerClient}
